import type {
  ClientOrganization,
  ClientOrganizationCreateRequest
} from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineOrganizationApi } from '@/features/api/hooks/grapevine-organization/useGrapevineOrganizationApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useCreateOrganization = () => {
  const queryClient = useQueryClient();
  const api = useGrapevineOrganizationApi();

  return useApiMutation<
    ClientOrganization,
    unknown,
    ClientOrganizationCreateRequest
  >({
    mutationFn: (clientOrganizationCreateRequest) =>
      api.createOrganization({ clientOrganizationCreateRequest }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.OWN_ORGANIZATIONS]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.POST_CREATION_OPTIONS]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATIONS]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATIONS_IN_GEO_AREA]
      });
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.ORGANIZATIONS_IN_OWN_GEO_AREA_SELECTION]
      });
    }
  });
};
